import { useOrgData } from '../accountant/useOrgData.js';
import type { Api } from '../api.js';
import { day, dollars } from '../format.js';

interface Balance {
  asAt: string | null;
  statementClosing: string | null;
  booksBalance: string;
  difference: string | null;
  toSort: number;
}

/** The bank's closing balance against the books, shown prominently (BRIEF.md section 9). */
export function BalanceCheck({
  api,
  orgId,
  bankAccountId,
  version,
}: {
  api: Api;
  orgId: string;
  bankAccountId: string;
  version: number;
}) {
  const { data } = useOrgData<Balance>(
    api,
    orgId,
    `/bank-accounts/${bankAccountId}/balance?v=${version}`,
  );
  if (!data?.asAt || data.statementClosing === null) return null;
  const matches = data.difference === '0.00';
  return (
    <p className={matches ? 'balance ok' : 'balance off'}>
      Bank on {day(data.asAt)}: {dollars(data.statementClosing)}. Your books:{' '}
      {dollars(data.booksBalance)}.{' '}
      {matches
        ? 'They match.'
        : data.toSort > 0
          ? `Differ by ${dollars(data.difference?.replace('-', '') ?? '0.00')}: ${data.toSort} transactions still to sort.`
          : `Differ by ${dollars(data.difference?.replace('-', '') ?? '0.00')}. Ask your accountant to check the opening balance.`}
    </p>
  );
}
